import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SubjectsCriteriaComponent } from '../subjects-criteria/subjects-criteria.component';

@Component({
  selector: 'app-deferment-criteria',
  templateUrl: './deferment-criteria.component.html',
  styleUrls: ['./deferment-criteria.component.scss']
})
export class DefermentCriteriaComponent implements OnInit {

  creditosPattern = '^(0?[1-9]|[1-9][0-9]{1,3})$';
  credits: number;

  @Input() program;
  @Input() nameProgram;
  @Input() version;
  @ViewChild('prerequisito') prerequiment: SubjectsCriteriaComponent;
  @ViewChild('corequisito') corequiment: SubjectsCriteriaComponent;

  constructor() { }

  ngOnInit() {
  }

}
